import { CurrencyId } from 'v2/interfaces/financial';

import type { INewAccount } from 'v2/interfaces/financial';

export const newAccount: INewAccount = {
  currency: CurrencyId.BRL,
  type: 'CC',
  bank_id: 'not-selected',
  operation_id: 'not-selected',
  document_number: '',
  name: '',
  agency: '',
  agency_digit: '',
  account: '',
  account_digit: '',
  imgsIds: {
    imgDocCNH: '',
    imgDocCPF: '',
    imgDocRG: '',
    imgBankReceipt: '',
    videoDoc: '',
  },
  notes: '',
};
